import { faSearch, faTimesCircle } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useTranslation from 'next-translate/useTranslation'

export const CasinoSearch = ({ searchTerm, setSearchTerm, clearSearchTerm }) => {
  const { t } = useTranslation('casino')

  return (
    <div className="casino-search flex items-center h-[52px] bg-form text-formContrast mx-2 md:mx-4 rounded shadow-lg border-[1px] border-formBorder hover:bg-formHover hover:text-formHoverContrast hover:border-formHoverBorder">
      <div className="casino-search-icon flex justify-center w-[52px]">
        <FontAwesomeIcon icon={faSearch} />
      </div>
      <div className="casino-search-input flex flex-grow h-full items-center">
        <input
          value={searchTerm}
          onChange={setSearchTerm}
          placeholder={t('Casino.searchPlaceholder')}
          className="casino-search-input-field w-full h-full bg-transparent focus:outline-none text-sm"
        />

        {searchTerm?.length > 0 && (
          <FontAwesomeIcon
            className="casino-search-input-clear px-4 opacity-50"
            icon={faTimesCircle}
            onClick={clearSearchTerm}
          />
        )}
      </div>
    </div>
  )
}
